import React, { FC } from 'react';
import ReactPaginate from 'react-paginate';

interface IPaginator {
  selected: number;
  hasNext: boolean;
  totalPages: number;
  showCount?: number;
  onCountSelect?: (x: number) => void;
  click: (data: { selected: number }) => void;
}

export const Paginator: FC<IPaginator> = ({
  hasNext,
  selected,
  showCount,
  totalPages,
  click,
  onCountSelect,
}) => {
  const [count, setCount] = React.useState(20);

  const handleChangeCount = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = parseInt(event.currentTarget.value);
    setCount(value);
    if (onCountSelect) {
      onCountSelect(value);
    }
  };

  React.useEffect(() => {
    setCount(showCount ?? 20);
  }, [showCount]);

  if (totalPages < 2) return null;

  return (
    <div className="flex items-center justify-between px-6 py-4 border-t border-neutral-200">
      <ReactPaginate
        breakLabel="..."
        nextLabel={
          <span className="flex items-center gap-1.5">
            Next <span>→</span>
          </span>
        }
        previousLabel={
          <span className="flex items-center gap-1.5">
            <span>←</span> Previous
          </span>
        }
        onPageChange={click}
        pageRangeDisplayed={window.innerWidth <= 768 ? 2 : 3}
        pageCount={totalPages}
        containerClassName="flex items-center gap-1 text-sm"
        pageClassName="h-9 w-9 rounded-lg flex items-center justify-center transition-colors"
        pageLinkClassName="h-full w-full medium flex items-center justify-center rounded-lg focus:outline-none"
        activeLinkClassName="bg-primary-medium text-primary"
        previousClassName={`mr-2 ${
          selected === 0
            ? 'text-neutral-300 cursor-not-allowed'
            : 'text-text hover:text-primary'
        }`}
        previousLinkClassName={`flex items-center gap-1.5 text-sm medium ${
          selected === 0 ? 'cursor-not-allowed' : ''
        }`}
        nextClassName={`ml-2 ${
          hasNext
            ? 'text-text hover:text-primary'
            : 'text-neutral-300 cursor-not-allowed'
        }`}
        nextLinkClassName={`flex items-center gap-1.5 text-sm medium ${
          !hasNext ? 'cursor-not-allowed' : ''
        }`}
        breakClassName="h-9 w-9 flex items-center justify-center"
        breakLinkClassName="h-full w-full flex items-center justify-center focus:outline-none text-neutral-500"
        forcePage={selected}
      />

      {showCount && onCountSelect ? (
        <div className="flex items-center gap-2 text-sm text-neutral-500">
          <span>Show on page</span>
          <select
            value={count}
            onChange={handleChangeCount}
            className="appearance-none bg-white border border-slate-medium rounded-lg px-3 py-1.5 pr-8 text-sm text-text focus:outline-none focus:border-primary bg-no-repeat bg-[length:12px] bg-[position:right_8px_center] bg-chevron-down"
          >
            {[10, 20, 30, 40, 50].map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};
